export default "__VITE_ASSET__c5220f96__"